module.exports = __webpack_public_path__ + "29c031bf53e8a9782e165c8ee3152ec8.png";